import { createContext } from 'react';

import { action, computed, makeAutoObservable } from 'mobx';
import { persist, create } from 'mobx-persist';
import { USER_TYPE } from 'types/Enum';
import { LoginResponse } from 'types/services/Auth';

const hydrate = create({});
class AuthStore {
  @persist
  id = '';

  @persist
  email = '';

  @persist
  token = '';

  @persist
  userType: USER_TYPE = '';

  finishedPersisting = false;

  constructor() {
    const self = this;
    makeAutoObservable(self);
    hydrate('authStore', self).then(() => {
      this.finishedPersisting = true;
    });
  }

  @action
  async onLogin(data: LoginResponse) {
    if (data.token) {
      this.id = data.body.id;
      this.token = data.token;
      this.email = data.body.email;
      this.userType = data.body.type;
    }
  }

  @action
  logout() {
    this.id = '';
    this.token = '';
    this.email = '';
    this.userType = '';
  }

  @computed
  get isAuthenticated() {
    return !!this.token;
  }
}

export const AuthStoreContext = createContext(new AuthStore());
